export enum Temperature {
  cool = 'COOL',
  warm = 'WARM',
  hot = 'HOT',
  unknown = 'UNKNOWN',
}
